import {
	Box,
	Button,
	ButtonGroup,
	DialogSteps,
	Flex,
	Separator,
} from '@welbe/design-system';
import type { MergedStepComponentProps } from '../MergeEmployeesDialog.types';

export const Footer = ({
	primaryEmployeeId,
	nextDisabled,
	loading,
	onBack,
	onNext,
	onClose,
}: Omit<MergedStepComponentProps, 'employees'> & {
	primaryEmployeeId?: string;
	nextDisabled?: boolean;
}) => {
	return (
		<>
			<Separator />
			<DialogSteps.Footer>
				<Box width="100%">
					<Flex justifyContent="space-between">
						<Button
							variant="ghost"
							size="sm"
							onClick={onClose}
							disabled={loading}
						>
							Cancelar
						</Button>
						<ButtonGroup size="sm">
							<Button variant="outline" onClick={onBack} disabled={loading}>
								Regresar
							</Button>
							<Button
								onClick={() => onNext(primaryEmployeeId)}
								disabled={nextDisabled}
								loading={loading}
							>
								Continuar
							</Button>
						</ButtonGroup>
					</Flex>
				</Box>
			</DialogSteps.Footer>
		</>
	);
};
